<template>
   <div class="div14 cutbox" :style="`background:url(${info.image}) no-repeat;background-size: 100% 100%;`">
          <div class="center-block">
            <div class="text1" data-id="主标题1" data-range="5,8">
               {{ info.titles[1] }}
               <!-- <span>{{ info.specialty[1] }}</span>{{ info.specialty[2] }} -->
            </div>
            <div class="text2" data-id="副标题1" data-range="9,12" data-content="生产型企业">
                {{ info.titles[0] }}
            </div>
         </div>
   </div>
</template>
<script>
export default {
   name: 'TUWEN014',
   props: {
      info: Object
   },
}
</script>
